import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./vue/app.vue";
import { useAuthStore } from "../newSrc/stores/authStore";

import piniaPluginPersistedState from "pinia-plugin-persistedstate";

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

app.use(pinia);

const authStore = useAuthStore();
authStore.setUserType("user");
authStore.state.isAuthenticated = false;
authStore.state.token = null;

createApp(App);
